<script setup>
import { computed, ref } from 'vue';

const props = defineProps({
  options: {
    type: Array,
    required: true,
    validator: value => {
      return value.every(
        option => typeof option.label === 'string' && option.value !== undefined
      );
    },
  },
  modelValue: {
    type: [String, Number],
    required: true,
  },
  placeholder: {
    type: String,
    default: 'Select option...',
  },
});

const emit = defineEmits(['update:modelValue', 'change']);

const isOpen = ref(false);

const selectedOption = computed(() => {
  return props.options.find(option => option.value === props.modelValue);
});

const toggleDropdown = () => {
  isOpen.value = !isOpen.value;
};

const selectOption = option => {
  emit('update:modelValue', option.value);
  emit('change', option);
  isOpen.value = false;
};

const closeDropdown = () => {
  isOpen.value = false;
};
</script>

<template>
  <div class="relative w-full">
    <button
      class="flex items-center justify-between w-full px-3 py-2 text-sm border border-n-weak rounded-lg bg-n-solid-2 text-n-slate-11 hover:border-n-strong focus:outline-none focus:border-n-brand focus:ring-1 focus:ring-n-brand transition-colors"
      @click="toggleDropdown"
      @blur="closeDropdown"
    >
      <span class="truncate">
        {{ selectedOption?.label || placeholder }}
      </span>
      <fluent-icon
        icon="chevron-down"
        size="16"
        class="ml-2 transition-transform"
        :class="{ 'rotate-180': isOpen }"
      />
    </button>

    <div
      v-show="isOpen"
      class="absolute z-50 w-full mt-1 bg-n-solid-2 border border-n-strong rounded-lg shadow-xl max-h-60 overflow-auto"
    >
      <div
        v-for="option in options"
        :key="option.value"
        class="px-3 py-2 text-sm cursor-pointer hover:bg-n-alpha-1 text-n-slate-11 hover:text-n-slate-12 transition-colors"
        :class="{
          'bg-n-alpha-black2 text-n-brand': option.value === modelValue,
        }"
        @mousedown="selectOption(option)"
      >
        {{ option.label }}
      </div>
    </div>
  </div>
</template>
